import { escapeRegExp } from "lodash-es";
/** 返回一个proxy过后的renderer
 * 会拦截获取dataStub相关的函数
 * 如果命中了给定path下面的dataStub就会返回自定义的dataStub来替代 */
export function getStubProxyRenderer(renderer, getEnable, getPath, getStub) {
  const getStubAtPath = function (...argumentsList) {
    const argStubPath = argumentsList[0];
    const proxyStubPath = getPath();
    if (!(argStubPath !== null && argStubPath !== void 0 && argStubPath.startsWith(proxyStubPath)) || !getStub()) {
      // 说明不是proxyStubPath下的路径 直接返回
      return renderer.getStubAtPath(...argumentsList);
    }
    // argStubPath="state.foobar.a" proxyStubPath="state.foobar" 这时候用"a"来取Stub
    const childPath = argStubPath.replace(new RegExp(`^${escapeRegExp(proxyStubPath)}\\.?`), '');
    const res = getStub().getStubAtPath(childPath);
    return res;
  };
  const proxyRenderer = new Proxy(renderer, {
    get(target, p, receiver) {
      const org = Reflect.get(target, p, receiver);
      if (!getEnable()) return org;
      if (p === 'getStubAtPath') {
        return getStubAtPath;
      }
      return org;
    }
  });
  return proxyRenderer;
}